export {
    ActivityCopyBar,
    COPY_TEXTS,
    copyPhotoPress,
    recordingLabel,
    type ActivityCopyBarProps,
    type ActivityCopyMedium,
    type ActivityCopyProps,
    type UICopyPhoto,
    type UICopyRecording,
} from "./ActivityCopyBar"
